import i18nHelper from '../../../myAccount/helper/i18n-helper';
export default {
  name: 'ChatbotIcon',
  computed: {
    hasLongLabel() {
      const languageCode = this.$store.state.browser.languageCode || this.$store.state.browser.cookies.languageCode || 'en-us';
      return ['ja-jp'].indexOf(languageCode) >= 0;
    }
  },
  methods: {
    getLabel(label) {
      return i18nHelper.getI18nMessage(label);
    }
  }
};